<template>
    <div
        class="flex w-full items-center border border-a-brown-d7c7b8 font-main text-14 lg:text-16 bg-white px-3 rounded-lg lg:px-4">
        <div class="flex-none leading-none">
            <img src="@/assets/icon/icon-search-gray.svg" />
        </div>
        <div class="flex-auto px-2 leading-none h-full">
            <input ref="input" class="bg-transparent placeholder-a-brown-9f8273 w-full py-2.5 lg:py-4 text-a-brown-502314" maxlength="50"
                type="text" :placeholder="lbl.myOrder.search_placeholder" :value="search" @input="onInput($event)" @keyup.enter="onEnter()"
                autocomplete="off" />
        </div>
        <div class="flex-none leading-none flex items-center">
            <button type="button" class="outline-none appearance-none bg-none" v-show="showBtnClear"
                @click="clickClear()">
                <img class="h-4 w-4 lg:h-5 lg:w-5" src="@/assets/icon/ic-close-brown.svg" />
            </button>
        </div>
    </div>
</template>
<script>
import { computed, ref, nextTick } from 'vue'

import Utility from '@/helper/Utility'
import RegxHelper from '@/helper/RegxHelper'
//mixin
import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    name: 'InputSearch',
    mixins: [LocaleMixin],
    props: {
        modelValue: {
            type: String,
        },
        delimeter: {
            type: String,
            default: "-"
        }
    },
    emits: ["onSearch", "update:modelValue"],
    data: function () { return {} },
    computed: {},
    setup: function (props, context) {
        const input = ref(null)

        const search = computed({
            get: () => {
                return props.modelValue
            },
            set: (val) => {
                context.emit("update:modelValue", val)
            }
        })

        const showBtnClear = computed(() => {
            if (!Utility.isEmptyStr(search.value)) {
                return true
            }
            return false
        })

        const onInput = function (e) {
            let value = e.target.value

            let input = Utility.isEmptyStr(value) ? '' : value;
            input = RegxHelper.removeEmoji(input);
            search.value = input
        }

        const validateInput = function () {
            // required
            if (Utility.isEmptyStr(search.value)) {
                return false;
            }

            return true
        }

        const clickClear = function () {
            search.value = ""
            nextTick(() => {
                input.value.focus()
            })

        }

        const onEnter = function () {
            let valid = validateInput()
            if (valid) {
                context.emit("onSearch", search.value)
            }
        }

        return {
            input,
            search,
            showBtnClear,
            onInput,
            onEnter,
            clickClear
        }
    },
    mounted: function () { },
    methods: {}
}
</script>
